import { render } from "./SurveyEdit.vue?vue&type=template&id=cf98c7b8&ts=true"
import script from "./SurveyEdit.vue?vue&type=script&lang=ts"
export * from "./SurveyEdit.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__